import React from "react";
import useScreenSize from "../hooks/useScreenSize";

const Wrapper = ({ children }) => {
    const { isMobile } = useScreenSize();
    return (<div className={`wrapper ${isMobile ? 'wrapper-mobile' : ''}`}>{children}</div>);
}

export default Wrapper;
